import { render, staticRenderFns } from "./RolesView.vue?vue&type=template&id=2b75b516&"
import script from "./RolesView.vue?vue&type=script&lang=ts&"
export * from "./RolesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports